
import React from "react";
import { Check, AlertCircle, ChevronRight } from "lucide-react";

interface StrengthsAndImprovementsProps {
  strengths: string[];
  improvements: string[];
}

const StrengthsAndImprovements: React.FC<StrengthsAndImprovementsProps> = ({ strengths, improvements }) => {
  return (
    <div>
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2 mb-3">
          <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
            <Check className="w-4 h-4 text-green-600" />
          </div>
          Key Strengths
        </h3>
        <ul className="space-y-2">
          {strengths.length > 0 ? (
            strengths.map((strength, index) => (
              <li key={index} className="flex items-start gap-2">
                <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-3 h-3 text-green-600" />
                </div>
                <span className="text-gray-700">{strength}</span>
              </li>
            ))
          ) : (
            <li className="text-gray-500 italic">No notable strengths identified</li>
          )}
        </ul>
      </div>
      
      <div>
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2 mb-3">
          <div className="w-6 h-6 rounded-full bg-yellow-100 flex items-center justify-center">
            <AlertCircle className="w-4 h-4 text-yellow-600" />
          </div>
          Improvement Areas
        </h3>
        <ul className="space-y-2">
          {improvements.length > 0 ? (
            improvements.map((improvement, index) => (
              <li key={index} className="flex items-start gap-2">
                <div className="w-5 h-5 rounded-full bg-yellow-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <ChevronRight className="w-3 h-3 text-yellow-600" />
                </div>
                <span className="text-gray-700">{improvement}</span>
              </li>
            ))
          ) : (
            <li className="text-gray-500 italic">No critical improvement areas identified</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default StrengthsAndImprovements;
